import { DataGrid } from "@mui/x-data-grid";

import Colors from "../../../global/Colors";

import Empty from "./Empty";

export default function CustomDataGrid({ columns, rows, sx, ...rest }) {
  return (
    <DataGrid
      getRowClassName={() => "border-t-0 rounded-xl hover:!bg-gray-100 cursor-pointer"}
      getCellClassName={() => "!border-t-0"}
      rows={rows}
      columns={columns}
      pagination={false}
      rowSelection={false}
      sx={{
        border: 0,
        "& .MuiDataGrid-cell.MuiDataGrid-cellEmpty": {
          borderTop: "none",
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          fontWeight: "700 !important",
        },
        "& .MuiDataGrid-columnHeader": {
          borderBottom: "none !important",
        },
        "& .MuiDataGrid-filler": {
          display: "none !important",
        },
        "& .MuiDataGrid-columnSeparator": {
          display: "none",
        },
        "& .MuiDataGrid-footerContainer": {
          borderTop: "none",
        },
        "& .MuiDataGrid-selectedRowCount": {
          display: "none",
        },
        "& .MuiButtonBase-root.MuiCheckbox-root": {
          color: Colors.gray[400],
        },
        "& .MuiButtonBase-root.MuiCheckbox-root.Mui-checked": {
          color: Colors.blue[700],
        },
        "& .MuiDataGrid-row.Mui-selected": {
          backgroundColor: Colors.gray[100],
        },
        "& .MuiTablePagination-root": {
          display: "none",
        },
        "& .MuiDataGrid-cell:focus": {
          outline: "none",
          backgroundColor: "inherit",
        },
        "& .MuiDataGrid-cell:focus-within": {
          outline: "none !important",
        },
        "& .MuiDataGrid-columnHeader:focus": {
          outline: "none",
          backgroundColor: "inherit",
        },
        ...sx,
      }}
      slots={{ noRowsOverlay: Empty }}
      {...rest}
    />
  );
}
